import React from "react";

import { SwiperCarousel } from "supercell-frontend-base/src/components/swiper-carousel";
import {
    CarouselSlide,
    SlideType,
} from "supercell-frontend-base/src/components/swiper-carousel/slide";
import { Grid } from "supercell-frontend-base/src/components/grid";
import { List } from "supercell-frontend-base/src/components/list";
import { ListArticle } from "supercell-frontend-base/src/components/list/article";
import { ContentfulSocialLinks } from "supercell-frontend-base/src/components/contentful-social-links";
import { Tab } from "supercell-frontend-base/src/components/inbox/tab";

import { filterNewsFeed } from "supercell-frontend-base/src/utils/filter-news-feed";
import { filterEntry } from "supercell-frontend-base/src/targeting/targeting";
import { BoomBeachGameParams } from "../../validation/game-params";
import { useGameParamsContext } from "supercell-frontend-base/src/stores/gameParams";

import styles from "./styles.modules.scss";

type NewsData = {
    events?: InboxEvent[];
    articles?: InboxArticle[];
    socialLinks?: SocialLink[];
};

export const NewsView = ({ hideSocialLinks }: { hideSocialLinks: boolean }) => (
    <Tab namespace="news">
        {({ locale, data: rawData }) => {
            const data = rawData as NewsData;
            const { gameParams } = useGameParamsContext<BoomBeachGameParams>();

            const filterArticles = (a: InboxArticle) =>
                filterNewsFeed(a) &&
                filterEntry(a, gameParams as BoomBeachGameParams);

            return (
                <div className={`news ${styles.news}`}>
                    <Grid>
                        {data.events ? (
                            <div className={`events ${styles.events}`}>
                                <div className="events-wrapper">
                                    <SwiperCarousel
                                        locale={locale}
                                        Slide={CarouselSlide}
                                        slides={
                                            data.events.filter(
                                                (e: InboxEvent) =>
                                                    filterEntry(
                                                        e,
                                                        gameParams as BoomBeachGameParams,
                                                    ),
                                            ) as unknown as SlideType[]
                                        }
                                    />
                                </div>
                            </div>
                        ) : null}

                        {data.articles ? (
                            <div className={`articles ${styles.articles}`}>
                                <List
                                    Item={ListArticle}
                                    items={
                                        data.articles.filter(
                                            (e: InboxArticle) =>
                                                filterArticles(e),
                                        ) as unknown as InboxArticle[][]
                                    }
                                    footer={
                                        hideSocialLinks ? null : (
                                            <ContentfulSocialLinks
                                                showBanner
                                                links={data.socialLinks}
                                            />
                                        )
                                    }
                                />
                            </div>
                        ) : null}
                    </Grid>
                </div>
            );
        }}
    </Tab>
);
